module.exports = __webpack_public_path__ + "static/media/app-icon-sj.b21e74be.svg";